<span>
  <span *ngIf="yesno">Yes</span>
  <span *ngIf="!yesno">No</span>
</span>
